import type { MessageKey } from "@/i18n";
import { useI18n } from "@/i18n";
import { ApiError } from "@/lib/api";
import { ErrorAlert } from "./ui/alert";

const KNOWN = new Set([
  "network_error",
  "otp_invalid",
  "otp_expired",
  "otp_attempts_exceeded",
  "captcha_failed",
  "rate_limited",
  "service_unavailable",
  "validation_failed",
  "conflict",
  "tenant_not_ready",
  "forbidden",
  "not_found",
  "plan_limit_reached",
]);

export function useErrorText() {
  const { t } = useI18n();
  return (error: unknown): string => {
    if (error instanceof ApiError && KNOWN.has(error.code)) {
      // Conflict details from the server are specific and worth showing as-is.
      if (error.code === "conflict" && error.problem?.detail) return error.problem.detail;
      return t(`errors.${error.code}` as MessageKey);
    }
    return t("errors.generic");
  };
}

export function ErrorMessage({ error }: { error: unknown }) {
  const text = useErrorText();
  if (!error) return null;
  return <ErrorAlert>{text(error)}</ErrorAlert>;
}
